var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"rect-loading",rawName:"v-rect-loading",value:(_vm.loading),expression:"loading"}],staticClass:"chatbot-management-container"},[_c('iframe',{ref:"iframe",staticClass:"iframe-container",attrs:{"src":_vm.chatbotUrl,"frameborder":"0","scrolling":"yes"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }